import { Device, DeviceInfo } from '@capacitor/device';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDeviceInfo = defineStore('device-info', () => {
  const deviceInfo = ref<DeviceInfo>();
  const deviceId = ref<string>();

  Device.getId().then((res) => {
    console.log('DEVICE ID', res.identifier);
    deviceId.value = res.identifier;
  });
  Device.getInfo().then((info) => {
    console.log('DEVICE INFO', info);
    deviceInfo.value = info;
  });

  return {
    deviceId,
    deviceInfo,
  };
});
